<template>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            opacity="0.1"
            d="M12.8888 7.69967L12.8859 10.2197C12.883 11.0538 12.2034 11.7334 11.3692 11.7334L2.61629 11.7159C2.21087 11.7159 1.83171 11.5584 1.54587 11.2697C1.26004 10.9838 1.10254 10.6018 1.10254 10.1963L1.10546 7.70259C1.17254 7.65009 1.25129 7.61217 1.33879 7.59467C1.37671 7.58592 1.41754 7.58301 1.45837 7.58301H12.5417C12.5796 7.58301 12.6205 7.58592 12.6555 7.59467C12.743 7.61217 12.8217 7.64717 12.8888 7.69967Z"
            fill="#118BEF"
        />
        <path
            opacity="0.2"
            d="M12.6555 7.59467L12.6526 10.2197C12.6526 10.9255 12.0751 11.5001 11.3693 11.5001L2.61635 11.4826C2.2751 11.4826 1.95135 11.3484 1.70927 11.1063C1.46719 10.8613 1.33594 10.5405 1.33594 10.1963L1.33885 7.59467C1.37677 7.58592 1.4176 7.58301 1.45844 7.58301H12.5418C12.5797 7.58301 12.6205 7.58592 12.6555 7.59467Z"
            fill="#118BEF"
        />
        <path
            opacity="0.3"
            d="M12.4223 7.58301L12.4193 10.2197C12.4193 10.7972 11.9468 11.2668 11.3693 11.2668L2.61642 11.2493C2.33642 11.2493 2.07392 11.1384 1.87559 10.9401C1.67725 10.7418 1.56934 10.4793 1.56934 10.1963L1.57225 7.58301H12.4223Z"
            fill="#118BEF"
        />
        <path
            opacity="0.4"
            d="M12.189 7.58301L12.1861 10.2168C12.1861 10.6688 11.8186 11.0334 11.3694 11.0334L2.6194 11.0159C2.40065 11.0159 2.19648 10.9313 2.0419 10.7768C1.88732 10.6222 1.80273 10.4151 1.80273 10.1993L1.80565 7.58301H12.189Z"
            fill="#118BEF"
        />
        <path
            d="M3.79166 2.05274L10.2264 2.06994C10.5487 2.07053 10.8092 2.33215 10.8086 2.65444L10.7928 10.2182C10.7922 10.5402 10.5306 10.801 10.2083 10.8004L3.77357 10.7832C3.45128 10.7826 3.19082 10.521 3.19141 10.1987L3.20716 2.6349C3.20774 2.31261 3.46966 2.05186 3.79166 2.05274Z"
            fill="url(#paint0_linear_2873_303)"
        />
        <path
            d="M3.20827 3.20996L10.8074 3.22717C11.1296 3.22775 11.3901 3.48938 11.3895 3.81167L11.3761 10.2187C11.3755 10.5407 11.1139 10.8015 10.7916 10.8009L3.19252 10.7837C2.87023 10.7831 2.60977 10.5215 2.61035 10.1992L2.62377 3.79213C2.62435 3.46984 2.88627 3.20938 3.20827 3.20996Z"
            fill="url(#paint1_linear_2873_303)"
        />
        <path
            d="M2.63143 4.36621L11.3808 4.38342C11.7031 4.384 11.9636 4.64563 11.963 4.96792L11.9522 10.2179C11.9516 10.5399 11.69 10.8007 11.3677 10.8001L2.6183 10.7832C2.29601 10.7826 2.03555 10.521 2.03613 10.1987L2.04693 4.94867C2.04751 4.62638 2.30913 4.36563 2.63143 4.36621Z"
            fill="url(#paint2_linear_2873_303)"
        />
        <path
            d="M3.20801 7.58342L4.7518 6.03963C4.86584 5.92559 5.05047 5.92559 5.16422 6.03963L6.70801 7.58342L7.66847 6.62297C7.78251 6.50892 7.96713 6.50892 8.08088 6.62297L9.04134 7.58342H3.20801Z"
            fill="url(#paint3_linear_2873_303)"
        />
        <path
            opacity="0.05"
            d="M11.9586 7V7.35L11.9557 7.46667L11.9528 10.2171C11.9528 10.5408 11.6903 10.8004 11.3695 10.8004L2.61947 10.7829C2.29572 10.7829 2.03613 10.5204 2.03613 10.1996L2.03905 7.46667L2.04197 7.35V7H11.9586Z"
            fill="#118BEF"
        />
        <path
            opacity="0.1"
            d="M11.9586 7.11621V7.34954L11.9557 7.46621L11.9528 10.2166C11.9528 10.5404 11.6903 10.8 11.3695 10.8L2.61947 10.7825C2.29572 10.7825 2.03613 10.52 2.03613 10.1991L2.03905 7.46621L2.04197 7.34954V7.11621H11.9586Z"
            fill="#118BEF"
        />
        <path
            opacity="0.2"
            d="M11.9586 7.2334V7.35007L11.9557 7.46673L11.9528 10.2171C11.9528 10.5409 11.6903 10.8005 11.3695 10.8005L2.61947 10.783C2.29572 10.783 2.03613 10.5205 2.03613 10.1996L2.03905 7.46673L2.04197 7.35007V7.2334H11.9586Z"
            fill="#118BEF"
        />
        <path
            opacity="0.3"
            d="M11.9586 7.34961L11.9557 7.46628L11.9528 10.2167C11.9528 10.5404 11.6903 10.8 11.3695 10.8L2.61947 10.7825C2.29572 10.7825 2.03613 10.52 2.03613 10.1992L2.03905 7.46628L2.04197 7.34961H11.9586Z"
            fill="#118BEF"
        />
        <path
            opacity="0.4"
            d="M11.9557 7.4668L11.9528 10.2172C11.9528 10.541 11.6903 10.8005 11.3695 10.8005L2.61947 10.783C2.29572 10.783 2.03613 10.5205 2.03613 10.1997L2.03905 7.4668H11.9557Z"
            fill="#118BEF"
        />
        <path
            d="M12.5417 7.58301H1.45833C1.13604 7.58301 0.875 7.84434 0.875 8.16634V11.3747C0.875 11.6967 1.13604 11.958 1.45833 11.958H12.5417C12.864 11.958 13.125 11.6967 13.125 11.3747V8.16634C13.125 7.84434 12.864 7.58301 12.5417 7.58301ZM8.02083 9.62467H5.97917C5.73767 9.62467 5.54167 9.42867 5.54167 9.18717C5.54167 8.94567 5.73767 8.74967 5.97917 8.74967H8.02083C8.26233 8.74967 8.45833 8.94567 8.45833 9.18717C8.45833 9.42867 8.26233 9.62467 8.02083 9.62467Z"
            fill="url(#paint4_linear_2873_303)"
        />
        <path
            d="M12.5417 7.72884C12.7829 7.72884 12.9792 7.92513 12.9792 8.16634V11.3747C12.9792 11.6159 12.7829 11.8122 12.5417 11.8122H1.45833C1.21712 11.8122 1.02083 11.6159 1.02083 11.3747V8.16634C1.02083 7.92513 1.21712 7.72884 1.45833 7.72884H12.5417ZM5.97917 9.77051H8.02083C8.34254 9.77051 8.60417 9.50888 8.60417 9.18717C8.60417 8.86547 8.34254 8.60384 8.02083 8.60384H5.97917C5.65746 8.60384 5.39583 8.86547 5.39583 9.18717C5.39583 9.50888 5.65746 9.77051 5.97917 9.77051ZM12.5417 7.58301H1.45833C1.13604 7.58301 0.875 7.84434 0.875 8.16634V11.3747C0.875 11.6967 1.13604 11.958 1.45833 11.958H12.5417C12.864 11.958 13.125 11.6967 13.125 11.3747V8.16634C13.125 7.84434 12.864 7.58301 12.5417 7.58301ZM5.97917 9.62467C5.73767 9.62467 5.54167 9.42867 5.54167 9.18717C5.54167 8.94567 5.73767 8.74967 5.97917 8.74967H8.02083C8.26233 8.74967 8.45833 8.94567 8.45833 9.18717C8.45833 9.42867 8.26233 9.62467 8.02083 9.62467H5.97917Z"
            fill="url(#paint5_linear_2873_303)"
        />
        <path
            d="M10.2083 6.41667C10.5305 6.41667 10.7917 6.1555 10.7917 5.83333C10.7917 5.51117 10.5305 5.25 10.2083 5.25C9.88617 5.25 9.625 5.51117 9.625 5.83333C9.625 6.1555 9.88617 6.41667 10.2083 6.41667Z"
            fill="url(#paint6_linear_2873_303)"
        />
        <path
            opacity="0.1"
            d="M8.02116 8.75H5.97949C5.73799 8.75 5.54199 8.946 5.54199 9.1875C5.54199 9.429 5.73799 9.625 5.97949 9.625H8.02116C8.26266 9.625 8.45866 9.429 8.45866 9.1875C8.45866 8.946 8.26266 8.75 8.02116 8.75Z"
            fill="#118BEF"
        />
        <path
            opacity="0.2"
            d="M8.02116 9.1C8.06928 9.1 8.10866 9.13937 8.10866 9.1875C8.10866 9.23562 8.06928 9.275 8.02116 9.275H5.97949C5.93137 9.275 5.89199 9.23562 5.89199 9.1875C5.89199 9.13937 5.93137 9.1 5.97949 9.1H8.02116ZM8.02116 8.75H5.97949C5.73799 8.75 5.54199 8.946 5.54199 9.1875C5.54199 9.429 5.73799 9.625 5.97949 9.625H8.02116C8.26266 9.625 8.45866 9.429 8.45866 9.1875C8.45866 8.946 8.26266 8.75 8.02116 8.75Z"
            fill="#118BEF"
        />
        <path
            opacity="0.3"
            d="M8.02116 8.98333C8.13374 8.98333 8.22533 9.07492 8.22533 9.1875C8.22533 9.30008 8.13374 9.39167 8.02116 9.39167H5.97949C5.86691 9.39167 5.77533 9.30008 5.77533 9.1875C5.77533 9.07492 5.86691 8.98333 5.97949 8.98333H8.02116ZM8.02116 8.75H5.97949C5.73799 8.75 5.54199 8.946 5.54199 9.1875C5.54199 9.429 5.73799 9.625 5.97949 9.625H8.02116C8.26266 9.625 8.45866 9.429 8.45866 9.1875C8.45866 8.946 8.26266 8.75 8.02116 8.75Z"
            fill="#118BEF"
        />
        <path
            opacity="0.4"
            d="M8.02116 8.86667C8.1982 8.86667 8.34199 9.01046 8.34199 9.1875C8.34199 9.36454 8.1982 9.50833 8.02116 9.50833H5.97949C5.80245 9.50833 5.65866 9.36454 5.65866 9.1875C5.65866 9.01046 5.80245 8.86667 5.97949 8.86667H8.02116ZM8.02116 8.75H5.97949C5.73799 8.75 5.54199 8.946 5.54199 9.1875C5.54199 9.429 5.73799 9.625 5.97949 9.625H8.02116C8.26266 9.625 8.45866 9.429 8.45866 9.1875C8.45866 8.946 8.26266 8.75 8.02116 8.75Z"
            fill="#118BEF"
        />
        <defs>
            <linearGradient
                id="paint0_linear_2873_303"
                x1="6.99748"
                y1="5.19781"
                x2="7.00786"
                y2="0.16733"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#009CFC" />
                <stop offset="1" stop-color="#97F8FF" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_2873_303"
                x1="6.99737"
                y1="6.93966"
                x2="7.00935"
                y2="1.13182"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#009CFC" />
                <stop offset="1" stop-color="#97F8FF" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_2873_303"
                x1="6.99008"
                y1="11.7148"
                x2="7.00983"
                y2="2.13919"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#009CFC" />
                <stop offset="1" stop-color="#97F8FF" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_2873_303"
                x1="6.12467"
                y1="8.54476"
                x2="6.12467"
                y2="3.07426"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#009CFC" />
                <stop offset="0.139" stop-color="#059FFC" />
                <stop offset="0.306" stop-color="#14A8FC" />
                <stop offset="0.489" stop-color="#2CB7FD" />
                <stop offset="0.683" stop-color="#4ECCFE" />
                <stop offset="0.882" stop-color="#7AE6FE" />
                <stop offset="1" stop-color="#97F8FF" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_2873_303"
                x1="7"
                y1="11.6366"
                x2="7"
                y2="8.33317"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#DAA6FF" stop-opacity="0.6" />
                <stop offset="1" stop-color="#DCA6FF" stop-opacity="0.4" />
            </linearGradient>
            <linearGradient
                id="paint5_linear_2873_303"
                x1="7"
                y1="11.958"
                x2="7"
                y2="7.58301"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#DAA6FF" stop-opacity="0.6" />
                <stop offset="1" stop-color="#DCA6FF" stop-opacity="0.4" />
            </linearGradient>
            <linearGradient
                id="paint6_linear_2873_303"
                x1="10.2083"
                y1="7.10529"
                x2="10.2083"
                y2="3.18763"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#009CFC" />
                <stop offset="1" stop-color="#97F8FF" />
            </linearGradient>
        </defs>
    </svg>
</template>
